import {useStudentSelector} from './useStudentSelector';

export const useIsAnyItemSelectedSelector = () => useStudentSelector((state) => state.currentItem !== null);
